import { useEffect, useState } from "react";
import { loadUserLocation, USER_LOCATION_CHANGED_EVENT } from "../utils/userLocation";

// Global user-location state: every consumer reads the same stored object,
// hydrated from localStorage and kept in sync via the change event
// (no component keeps its own copy).
const useUserLocation = () => {
    const [userLocation, setUserLocation] = useState(loadUserLocation);

    useEffect(() => {
        const sync = () => setUserLocation(loadUserLocation());
        window.addEventListener(USER_LOCATION_CHANGED_EVENT, sync);
        window.addEventListener("storage", sync);
        return () => {
            window.removeEventListener(USER_LOCATION_CHANGED_EVENT, sync);
            window.removeEventListener("storage", sync);
        };
    }, []);

    return userLocation;
};

export default useUserLocation;
